import { useState } from 'react';

/**
 * アップロード前のローカル画像のプレビュー。
 * HEIC など表示できない形式 (Chrome の HEIC 等) は、ファイル名と「アップロード時に変換される」旨を出す。
 * src が変わったら作り直すよう、呼び出し側で key={src} を付けること。
 */
export function LocalImagePreview({ src, fileName }: { src: string; fileName?: string }) {
  const [failed, setFailed] = useState(false);
  if (failed) {
    return (
      <div className="upload-preview-fallback">
        {fileName && <span className="upload-preview-fallback-name">{fileName}</span>}
        <span>この形式はプレビューできません (アップロード時に JPEG / PNG に変換されます)</span>
      </div>
    );
  }
  return <img src={src} alt="プレビュー" onError={() => setFailed(true)} />;
}
